import React from 'react';
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {useStyles } from './../Complements/usesStyles'
import clsx from "clsx";
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import Footer from '../Complements/Footer';

const MainMultiplePanels = props => {
    const {  info, chart, body } = props
    const classes = useStyles(props);
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    return (
        <main className={classes.content}>
            <Container maxWidth="lg" className={classes.container}>
            {
                !isMobile ?
                <Grid container spacing={3}>
                    {/* Recent Deposits */}
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper className={fixedHeightPaper}> { body } </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <Paper className={fixedHeightPaper}> { info } </Paper>
                    </Grid>
                    {/* Chart */}
                    <Grid item xs={12} md={6} lg={6}>
                    <Paper className={fixedHeightPaper}>
                        { chart }
                    </Paper>
                    </Grid>
                </Grid> :
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper className={fixedHeightPaper}> { body } </Paper>
                    </Grid>
                    {/* Chart */}
                    <Grid item xs={12} md={8} lg={8}>
                        <Paper className={fixedHeightPaper}>
                        { chart }
                    </Paper>
                    </Grid>
                    {/* Recent Deposits */}
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper >{ info }</Paper>
                    </Grid>
                </Grid>
            }
            <br />
            <Footer />
            </Container>
        </main>
    );
};

MainMultiplePanels.propTypes = {
    info: PropTypes.node.isRequired,
    chart: PropTypes.node.isRequired,
};

export default MainMultiplePanels;